import { render, staticRenderFns } from "./SeguimientoCargueExcel.vue?vue&type=template&id=38d803ea"
import script from "./SeguimientoCargueExcel.vue?vue&type=script&lang=js"
export * from "./SeguimientoCargueExcel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports